const data = {
  counterText: 'Nur wenige Plätze verfügbar',
  loading: 'Lade',
  next: 'Weiter',
  previous: 'Zurück',
  smCounterText: 'Nur noch wenige Plätze!',
};

export default data;
